import { useRef } from 'react';

export const useScrollToRef = <T extends HTMLElement>() => {
  const ref = useRef<T>(null);

  const scrollTo = ({
    offset = 0,
  }: {
    offset?: number;
  } = {}) => {
    if (ref.current) {
      const rect = ref.current.getBoundingClientRect();
      const scrollTop = window.pageYOffset + rect.top - offset;

      window.scrollTo({ top: scrollTop, behavior: 'smooth' });
    }
  };

  return { ref, scrollTo };
};
